import { toJS } from 'mobx';
import { BillStatusType } from '../utils'
import { WorkFlowStore } from '@stores/workflowstore'

/**
 * 审批
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  cardStoreKey: string， 默认值：cardStore
 *  approvalDataSourceAlias: string， 默认值：审批流组件的 数据源别名
 * }
 * @param storeObj {
 *  rowStore 列表页store
 * }
 * @returns
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export const approval = {
  async doAction(rootStore: any, options: any, event: any, storeObj: any) {
    const { pageStore = {} } = rootStore
    const { approvalDataSourceAlias = '', cardStoreKey = 'cardStore' } = toJS(options ?? {})
    // 处理$el，画到指定el容器里
    let $el = ''
    const billId = storeObj?.rowStore ? storeObj.rowStore.getValue('id') : pageStore.params.billId
    if (approvalDataSourceAlias) {
      $el = `${approvalDataSourceAlias}_${billId}`
      if (!document.getElementById($el)) {
        console.error(`DOM元素【${$el}】不存在`)        
      }
      $el = `#${$el}`
    }
    if (storeObj?.rowStore) {
      // 列表页打开审批
      if (!rootStore.workFlowStore) {
        // 没有workFlowStore就new一个
        rootStore.workFlowStore = new WorkFlowStore({
          isTable: true,
          rowStore: storeObj.rowStore,
          rootStore: rootStore
        })
      } else {
        // 有的话就改一下rowStore
        rootStore.workFlowStore.rowStore = storeObj.rowStore
      }
      // workflowstore里的flowJsLoaded为true后再画流程图
      const timer = setInterval(() => {
        if (rootStore.workFlowStore.flowJsLoaded) {
          clearInterval(timer)
          rootStore.workFlowStore.showOldFlow($el)
        }
      }, 100)
    } else {
      // 详情页打开审批
      const cardStore = rootStore.get(cardStoreKey);
      const formName = cardStore.formStore
      const form = rootStore.getStoreByAlias(formName)
      const terminalType = rootStore.pageStore.params?.terminalType || '3'
      if (terminalType === '1') {
        // pc端直接调用新版方法
        const timer = setInterval(() => {
          if (form.workFlowStore.latestStatus) {
            clearInterval(timer)
            form.workFlowStore.flowInstance.renderWorkFlowHistory($el)
          }
        }, 100)  
      } else {
        // 移动端还得用旧版的显示审批的弹窗
        form.workFlowStore.showOldFlow($el)
      }
    }
  }
}
